export default __webpack_public_path__ + "static/media/icon_danhgia.c0a7ff58.svg";